import { ReactNode } from "react";

// Detect *any* list type and return as unordered
const ANY_LIST_MARKER = /^(\s*)(\d+\.\s+|[a-zA-Z]\.\s+|[ivxlcIVXLC]+\.\s+|[-*+]\s+)/;

// Inline markdown styling (bold, italic, underline) + IMAGES
function formatText(text: string, key: number | string = ''): ReactNode {
  // Handle images first ![alt](url)
  let html = text.replace(/!\[(.*?)\]\((https?:\/\/[^\s)]+)\)/g, (match, alt, url) => {
    return `<img src="${url}" alt="${alt}" style="max-width: 100%; height: auto; margin: 8px 0; border-radius: 8px;" />`;
  })
  .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
  .replace(/__(.*?)__/g, '<strong>$1</strong>')
  .replace(/(\s|^)\*(.*?)\*(\s|$)/g, '$1<em>$2</em>$3')
  .replace(/_(.*?)_/g, '<em>$1</em>')
  .replace(/~~(.*?)~~/g, '<u>$1</u>')
  // .replace(/{{(.*?)}}/g, (match, url) => {
  //   return `
  //   <div style="padding: 2px; ">
  //     <img src="${url.trim()}" alt="image" style="width:80%; margin-top:20px"/>
  //   </div>`;
  // });

  
  return <span key={key} dangerouslySetInnerHTML={{ __html: html }} />;
}

// Recursive unordered list renderer
function renderUL(node: any, parentKey: string): ReactNode {
  return (
    <ul key={parentKey} style={{ paddingLeft: 0 }}>
      {node.items.map((li: any, idx: number) => (
        <li key={parentKey + '-li-' + idx}>
          {li.value}
          {li.child ? renderUL(li.child, parentKey + '-ul-' + idx) : null}
        </li>
      ))}
    </ul>
  );
}

export function renderChatMarkdown(mdText: string): ReactNode[] {
  const lines = mdText.replace(/\r\n?/g, '\n').split('\n');
  const result: ReactNode[] = [];
  const stack: any[] = [];
  let keyCounter = 0;

  function flushStack(depth = 0) {
    while (stack.length > depth) {
      const node = stack.pop();
      if (stack.length === 0) {
        result.push(renderUL(node, 'top-' + (keyCounter++)));
      } else {
        const parent = stack[stack.length - 1];
        if (parent.items.length) {
          parent.items[parent.items.length - 1].child = node;
        }
      }
    }
  }

  lines.forEach((rawLine, idx) => {
    const line = rawLine.replace(/\t/g, '    ');
    const trimmed = line.trim();
    
    if (!trimmed) {
      flushStack(0);
      result.push(<br key={`br-${keyCounter++}`} />);
      return;
    }

    // Detect any list marker (will always use UL)
    const match = ANY_LIST_MARKER.exec(line);
    if (match) {
      const indent = match[1].length;
      const content = line.replace(match[0], '');
      let depth = 0;
      while (depth < stack.length && indent > stack[depth].indent) {
        depth++;
      }
      while (stack.length > depth && stack[stack.length - 1].indent >= indent) {
        flushStack(stack.length - 1);
      }
      if (!stack[depth] || stack[depth].indent !== indent) {
        stack.length = depth;
        stack.push({
          type: 'ul',
          indent: indent,
          items: []
        });
      }
      stack[depth].items.push({
        value: formatText(content, idx),
        child: null
      });
      stack.length = depth + 1;
      return;
    }

    // Not a list: flush all lists, then render block
    flushStack(0);
    if (/^(\*\*|__)[^*]+(\*\*|__)\s*$/.test(trimmed)) {
      result.push(
        <div key={`heading-${keyCounter++}`} style={{ fontWeight: 600, margin: "6px 0" }}>
          {formatText(trimmed, idx)}
        </div>
      );
      return;
    }
    result.push(
      <div key={`p-${keyCounter++}`} style={{ marginBottom: 4 }}>
        {formatText(line, idx)}
      </div>
    );
  });

  flushStack(0);
  return result;
}
